module.exports = __webpack_public_path__ + "assets/img/mecha-7797a610.png";